export default __webpack_public_path__ + "static/media/2.c24dff5e.jpeg";